export enum ViewLoginUserTwoFactorStatusEnum {
	UNCHECKED = "UNCHECKED",
	REQUIRED = "REQUIRED",
	UNREQUIRED = "UNREQUIRED",
}
